export const stats = [
  { value: '6', label: 'Volumes Complets' },
  { value: '400+', label: 'Pages de Ressources' },
  { value: '200+', label: 'Exercices Détaillés' },
  { value: '100%', label: 'Prêt pour le Terrain' },
]

export const beforeItems = [
  'Passer vos soirées à chercher des exercices sur YouTube.',
  'Arriver au gymnase sans un vrai plan de progression.',
  "Aucune suite logique : vos joueurs finissent par s'ennuyer.",
  'Improviser la tactique et la préparation physique.',
  'Se sentir frustré parce que la préparation gâche votre plaisir.',
]

export const afterItems = [
  'Une année entière cartographiée et organisée.',
  "Des séances et des fiches prêtes à l'impression.",
  'Un curriculum en spirale des U7 aux Seniors.',
  'Planification pas à pas, même pour les débutants.',
  'Évaluations intégrées pour mesurer les progrès réels.',
]

export const recognizeItems = [
  "Vous n'avez plus de temps pour planifier des entraînements vraiment engageants.",
  "Vous voyez vos joueurs s'ennuyer avec les mêmes exercices répétitifs.",
  'Gérer des niveaux différents dans la même équipe vous semble impossible.',
  'Vous entraînez le basket mais vous avez peur de manquer de structure tactique.',
]

export type Volume = {
  number: number
  title: string
  text: string
}

export const volumes: Volume[] = [
  {
    number: 1,
    title: 'Programme 365 Jours',
    text: 'La feuille de route annuelle complète. Une planification structurée semaine après semaine.',
  },
  {
    number: 2,
    title: 'Attaque Dynamique',
    text: 'Espacement, continuité et lecture de jeu. Construisez une menace offensive constante.',
  },
  {
    number: 3,
    title: 'Le Mur Défensif',
    text: 'Défense individuelle, zone et aide. Apprenez à vos joueurs à protéger le cercle comme des pros.',
  },
  {
    number: 4,
    title: 'Systèmes de Jeu',
    text: 'Remises en jeu, systèmes contre zone et tactiques spéciales de fin de match.',
  },
  {
    number: 5,
    title: 'Tir et Fondamentaux',
    text: 'La mécanique de tir parfaite, le maniement du ballon et la finition au cercle.',
  },
  {
    number: 6,
    title: 'Préparation Physique et Mental',
    text: 'Vitesse, détente, agilité et gestion psychologique du vestiaire.',
  },
]

export const bonuses = [
  {
    title: 'Le Kit de Scouting Simplifié',
    text: 'Analysez vos adversaires comme un pro : fiches de repérage claires et prêtes à remplir.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/cf46117e-c734-4164-9dfb-c3342991d402.jpg',
  },
  {
    title: 'Le Planificateur de Saison Stratégique',
    text: "Votre calendrier annuel prêt à l'emploi : matchs, cycles de travail et périodes de récupération.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7084c089-3233-451f-9d49-9f9bfd8e00d3.jpg',
  },
  {
    title: "Protocole : Culture d'Équipe et Discipline",
    text: "Construisez le respect et l'engagement, du premier entraînement à la finale.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/60b19b47-73f0-477a-80f9-f78bac15c955.jpg',
  },
  {
    title: 'Le Guide des Tests de Performance',
    text: "Mesurez la vitesse, la détente et l'adresse avec des protocoles simples et fiables.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/3c47704f-9658-44cb-890a-b623def727de.jpg',
  },
  {
    title: 'Certificats et Récompenses MVP',
    text: 'Des outils pour motiver et récompenser vos athlètes tout au long de la saison.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/35c65ba3-fc8c-474b-a120-e293e31001ae.jpg',
  },
]

export const offerRows = [
  { label: 'Pack Basketball Prêt (6 Volumes)', value: '97€' },
  { label: '5 Bonus Stratégiques', value: '185€' },
]

export const testimonials = [
  {
    quote:
      "J'ai planifié toute ma saison en une seule soirée. J'ai enfin récupéré mes dimanches.",
    name: 'Jean M.',
    role: 'Entraîneur en France',
  },
  {
    quote:
      'Les progressions sont logiques. On sent que le système a été créé par des gens de terrain.',
    name: 'David B.',
    role: 'Coach en Belgique',
  },
]

export const faqs = [
  {
    q: 'Dans quel format sont les documents ?',
    a: 'Ce sont des PDF haute résolution prêts à imprimer ou à consulter sur le banc depuis votre tablette.',
  },
  {
    q: "Est-ce adapté si je débute comme entraîneur ?",
    a: 'Oui, chaque séance est expliquée pas à pas : objectifs, exercices, durées et points de coaching.',
  },
  {
    q: 'Comment vais-je recevoir le matériel ?',
    a: 'Immédiatement après le paiement, par email.',
  },
  {
    q: 'Est-ce que cela couvre tous les niveaux ?',
    a: 'Oui, les progressions vont des U7 aux Seniors, avec des variantes pour adapter chaque exercice.',
  },
]

export const heroGuarantees = [
  'Téléchargement numérique instantané',
  "PDF prêts pour l'impression",
  'Paiement unique',
]

export const footerLinks = [
  'Conditions Générales',
  'Politique de Confidentialité',
  'Contact',
]
